import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';
import { Profession } from 'src/app/interface/profession';
import { LayoutService } from 'src/app/service/layout.service';
import { ProfessionService } from 'src/app/service/profession.service';
import { SnackbarService } from 'src/app/service/snackbar.service';
import { SingleClickDirective } from 'src/app/shared/directives/single-click.directive';

@Component({
  selector: 'app-profession-edit-create',
  standalone: true,
  imports: [
    CommonModule,

    TranslateModule,
    SingleClickDirective,

    MatDialogTitle,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatDialogContent,
    MatButton,
    MatDialogActions,
    MatInput
  ],
  templateUrl: './profession-edit-create.component.html',
  styleUrl: './profession-edit-create.component.scss'
})
export class ProfessionEditCreateComponent implements OnInit {
  profession: Profession;
  form: FormGroup;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { profession: Profession },
    private dialogRef: MatDialogRef<ProfessionEditCreateComponent>,
    private _professionService: ProfessionService,
    private _layout: LayoutService,
    private _snackbar: SnackbarService,
    private _formBuilder: FormBuilder,

  ) {
    if(this.data){
      this.profession = data.profession ;
    }
  }

  ngOnInit() {
    this.buildForm()
  }

  buildForm() {
    if (this.profession) {
      this.form = this._formBuilder.group({
        _id: this.profession._id,
        description: [this.profession.description, Validators.required]
      })
    } else {
      this.form = this._formBuilder.group({
        id: "",
        description: ["", Validators.required],
      })
    }
  }

  async onSubmit(){
    const newProfession: Profession = this.form.getRawValue()
    const isUpdate = Boolean(newProfession._id);
    try {
      this._layout.loader = true
      if (isUpdate) {
        await this._professionService.update(newProfession)
        this._snackbar.success('PROFESSION.UPDATED');
      } else {
        const id = await this._professionService.register(newProfession);
        newProfession._id = id;
        this._snackbar.success('PROFESSION.ADDED');
      }
      this.dialogRef.close(newProfession);
    } catch (error) {
      console.error(error)
      this._snackbar.error(isUpdate ? 'PROFESSION.NOT_UPDATED' : 'PROFESSION.NOT_ADDED');
    } finally {
      this._layout.loader = false;
    }
  }

  close() {
    this.dialogRef.close(null);
  }
}
